import { z } from "zod";

import { CosignatureRequirementReasonEnum } from "@/core/constants/cosignature";

export const cosignatureFormSchema = z
  .object({
    requirementReason: z.union([
      z.enum(Object.values(CosignatureRequirementReasonEnum)),
      z.literal(""),
    ]),
    requirementReasonDetails: z.string().nullable(),
    supervisorId: z.guid(),
  })
  .superRefine((data, ctx) => {
    if (!data.requirementReason) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["requirementReason"],
      });
    }
    if (data.requirementReason === "Other" && !data.requirementReasonDetails) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Required",
        path: ["requirementReasonDetails"],
      });
    }
  });

export type CosignatureFormValues = z.infer<typeof cosignatureFormSchema>;
